import { useRouter } from 'next/router'
import { useEffect } from 'react'

import EmpriseGroup from '~/services/EmpriseGroup'

const useCreatePaypalOrder = () => {
  const { query, replace } = useRouter()
  const type = query?.type as string
  const token = query?.token as string

  const createPaypalOrder = async (token: string) => {
    try {
      await EmpriseGroup.createPaypalOrder(token)

      replace({ ...(!!type && { query: { type } }) })
    } catch (error) {
      console.error(error)
    }
  }

  useEffect(() => {
    if (!token) return

    createPaypalOrder(token)
  }, [token])
}

export default useCreatePaypalOrder
